import React from 'react';
import { Link } from 'react-router-dom';
import config from '../../../config';

const { marketingAppHost } = config;

const PrismicLink = (props) => {
    const { children, link, useAnchor, target, testId, 'data-testid': dataTestId /* , options */ } = props;

    if (link) {
        if (useAnchor || link.startsWith('http')) {
            // external urls, like support page
            return <a href={link} target={target || '_blank'} data-test={testId} data-testid={dataTestId || undefined}>{children}</a>;
        }

        if (link.startsWith('app:')) {
            // internal routing within utr app
            return <Link to={link.replace('app:', '')} target={target || '_self'} data-test={testId} data-testid={dataTestId || undefined}>{children}</Link>;
        }

        // links pointing to the marketing app
        return <a href={`${marketingAppHost}${link}`} target={target || '_self'} data-test={testId} data-testid={dataTestId || undefined}>{children}</a>;
    }

    return null;
};

export default PrismicLink;
